import React, { useEffect, useRef, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import LogoutIcon from "@mui/icons-material/Logout";
import { IconButton, Avatar, Badge, useMediaQuery } from "@mui/material";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InputAdornment, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { list_notification } from "../redux/notification/list-notification-reducer";
import { useSelector } from "react-redux";
import { read_one_notification } from "../redux/notification/single-notification-read";
import { Navigate, useNavigate } from "react-router";
import { addPartnerData } from "../redux/business-partner/partner-master/partner-master-first-data";
import { raise_api_call_list_partner_master } from "../redux/business-partner/partner-master/list-partner-master";
import HamburgerImg from "../assets/images/hamburger.svg";
import CollapseImg from "../assets/images/collapse_arrow.svg";
import ArrowImg from "../assets/images/left-arrow.svg";
import NotificationImg from "../assets/images/notifications.svg";
import ProfileImg from "../assets/images/profile.svg";
import LogoutImg from "../assets/images/logout.svg";
import { useCommonContext } from "../Utils/commonContext";
import BreadcrumbComponent from "../Components/Breadcrumb/Breadcrumb";

type Props = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const Header: React.FC<Props> = ({ isOpen, setIsOpen }) => {
  const { titleContext, showBack, setShowBack, onBackClick } =
    useCommonContext();
  const isMobile = useMediaQuery("(max-width: 1050px)");
  const [notification, setNotification] = useState<boolean>(false);

  const notificationIconRep = useRef<any>();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ListNotificationApi = useSelector(
    (state: any) => state.ListNotification
  );
  const ReadOneNotification = useSelector(
    (state: any) => state.ReadOneNotification
  );

  useEffect(() => {
    dispatch(list_notification(""));
    dispatch(raise_api_call_list_partner_master(""));
  }, [ReadOneNotification]);

  const notificationNumber =
    ListNotificationApi.data.length != 0
      ? ListNotificationApi.data.result.filter((e: any) => {
          if (!e.seen) {
            return e;
          }
        }).length
      : 0;

  return (
    <div className="header_container">
      <div className="header_content">
        <div className="header_content_mini">
          {!showBack || !isMobile ? (
            <div className="d-flex align-items-center">
              <img
                className="collapse_arrow"
                style={{
                  transform: !isOpen ? "rotate(180deg)" : "rotate(0deg)",
                }}
                src={CollapseImg}
                alt=""
                onClick={() => setIsOpen(!isOpen)}
              />
              <img
                className="hamburger_img"
                style={{ marginRight: "10px" }}
                src={HamburgerImg}
                alt=""
                onClick={() => setIsOpen(!isOpen)}
              />
              <BreadcrumbComponent />
            </div>
          ) : (
            <img
              src={ArrowImg}
              style={{ width: "20px",marginInline:"5px" }}
              alt=""
              onClick={onBackClick}
            />
          )}
          <h4 className="f4 title text_ellipsis">{titleContext}</h4>
        </div>
        <div className="header_content_mini">
          <div className="head_notifications">
            <img
              className="me-3"
              src={NotificationImg}
              alt=""
              onClick={() => setNotification(!notification)}
            />
            <div>{notificationNumber}</div>
          </div>
          <img src={ProfileImg} alt="" />
          <h4 className="f4">{localStorage.getItem("userName")}</h4>
          <img
            src={LogoutImg}
            alt=""
            onClick={() => {
              localStorage.removeItem("SpApperalsToken");
              localStorage.removeItem("SpApperalsRole");
              localStorage.removeItem("SpToken");
              window.location.pathname = "/login";
              // navigate("/login");
            }}
          />
        </div>
      </div>
      {notification ? (
        <Notifications
          notification={notification}
          ListNotificationApi={ListNotificationApi}
          setNotification={setNotification}
          notificationIconRep={notificationIconRep}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default Header;

const Notifications = (props: any) => {
  const { ListNotificationApi } = props;
  const notificationRep = useRef<any>();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const PartnerMasterList = useSelector(
    (state: any) => state.listPartnerMaster
  );

  useEffect(() => {
    const closeNotification = (e: MouseEvent) => {
      const notifRef = notificationRep.current;
      const iconRef = props.notificationIconRep?.current;

      if (
        notifRef &&
        iconRef &&
        !notifRef.contains(e.target as Node) &&
        !iconRef.contains(e.target as Node)
      ) {
        props.setNotification(false);
      }
    };

    document.addEventListener("mousedown", closeNotification);
    return () => document.removeEventListener("mousedown", closeNotification);
  }, [props]);

  return (
    <>
      <div
        ref={notificationRep}
        className="notifications p-4"
        style={{
          overflow: "hidden",
        }}
      >
        <div className="position-relative">{/* <KeyboardArrowUpIcon /> */}</div>
        <div className="title d-flex border-bottom">
          <p
            className="me-auto mb-3"
            style={{
              fontWeight: "700",
            }}
          >
            Notification
          </p>
          <p
            className="ms-auto mb-3"
            style={{
              textDecorationLine: "underline",
              color: "#46A4E3",
              fontWeight: "700",
              cursor: "pointer",
            }}
            onClick={() => {
              dispatch(read_one_notification({ url: "all" }));
            }}
          >
            Read all
          </p>
        </div>
        <div className="notifications_content">
          {ListNotificationApi.data.length != 0 ? (
            ListNotificationApi.data.message ? (
              ListNotificationApi.data.result.map((e: any) => {
                const monthNames = [
                  "Jan",
                  "Feb",
                  "Mar",
                  "Apr",
                  "May",
                  "Jun",
                  "Jul",
                  "Aug",
                  "Sep",
                  "Oct",
                  "Nov",
                  "Dec",
                ];
                const avatar_name: any = Array.from(e.title)[0];
                const created_on = new Date(e.created_on);
                // delete data.EffecDate;
                const created_date =
                  created_on.getDate() +
                  "-" +
                  monthNames[created_on.getMonth()] +
                  "-" +
                  created_on.getFullYear();
                const date = created_date;

                return (
                  <>
                    <div className="content d-flex mt-4 align-items-center">
                      <Avatar className="heder-avatar avatar">
                        {avatar_name}
                      </Avatar>
                      <div
                        className="values px-2 ps-3 me-auto"
                        id={e.seen ? "readed" : ""}
                        onClick={() => {
                          dispatch(
                            read_one_notification({ id: e.id, url: "" })
                          );
                          const data =
                            PartnerMasterList.data.length != 0
                              ? PartnerMasterList.data.result.filter(
                                  (a: any) => {
                                    if (
                                      Number(a.id) === Number(e.partnerMasterId)
                                    ) {
                                      return a;
                                    }
                                  }
                                )
                              : [];
                          dispatch(
                            addPartnerData(data.length != 0 ? data[0] : {})
                          );
                          navigate("/business-partner/partner-details");

                          props.setNotification(false);
                        }}
                      >
                        <h5>{e.title}</h5>
                        <p className="mb-0">{e.description}</p>
                      </div>
                      <p
                        className="mb-0 "
                        style={{
                          width: "100px",
                        }}
                      >
                        {date}
                      </p>
                    </div>
                  </>
                );
              })
            ) : (
              <div className="d-flex justify-content-center align-items-center">
                No Notification Found
              </div>
            )
          ) : (
            <div className="d-flex justify-content-center align-items-center">
              No Notification Found
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const useClickOutside = () => {};
